// src/Config/fieldMapping.js

export const FIELD_MAPPING = {
  product_name: 'name',
    sku: 'sku',
  barcode: 'barcode',
  model: 'model',
  serial_number: 'serial_number',
  warranty_period:'warranty_period',
  processor: 'processor',
  ram: 'ram',
  storage: 'storage',
  display_size: 'display_size',
  battery_capacity: 'battery_capacity',
  operating_system: 'operating_system',
  power_rating: 'power_rating',
  voltage: 'voltage',
  material: 'material',
  dimensions: 'dimensions',
  weight: 'weight',
  color_ids: 'color',
    unit_id: "unit_id",
  size_ids: 'size',
  finish: 'finish',
  thickness: 'thickness',
  purity: 'purity',
  gemstone: 'gemstone',
  certificate: 'certificate',
  sport_type: 'sport_type',
  skill_level: 'skill_level',
  fabric_type: 'fabric_type',
  style: 'style',
  fit: 'fit',
  pattern: 'pattern',
  gender: 'gender',
  season: 'season',
  collection: 'collection',
  occasion: 'occasion',
  sleeve_type: 'sleeve_type',
  neck_type: 'neck_type',
  closure_type: 'closure_type',
  country_of_origin: 'country_of_origin',
  manufacturer: 'manufacturer',
  chemical_formula: 'chemical_formula',
  grade: 'grade',
  hazards: 'hazards',
  storage_conditions: 'storage_conditions',
  wattage: 'wattage',
  efficiency: 'efficiency',
  power_output: 'power_output',
  rotor_diameter: 'rotor_diameter',
  hub_height: 'hub_height',
  pipe_size: 'pipe_size',
  pressure_rating: 'pressure_rating',
  temperature_rating: 'temperature_rating',
  installation_type: 'installation_type',
  panel_type: 'panel_type',
  project_type: 'project_type',
  emergency: 'emergency',
  maintenance_contract: 'maintenance_contract',
  category_id: 'category_id',
  subcategory_id: 'sub_category_id',
  unit_id: 'unit_id',
  purchase_price: 'cost_price',
  selling_price: 'price',
  mrp: 'mrp',
 discount_percent: 'discount_percent',
  discount_type: 'discount_type',
  min_stock_level: 'min_stock_level',
  reorder_level: 'reorder_level',
  stock: 'stock',
  gst_percentage: 'tax_percent',
  hsn_code: 'hsn_code',
  service_type: 'service_type',
  service_duration: 'service_duration',
  platform: 'platform',
  reach: 'reach',
  duration: 'duration',
  deliverables: 'deliverables',
  booking_required: 'booking_required',
  event_type: 'event_type',
  event_duration: 'event_duration',
  capacity: 'capacity',
  services_included: 'services_included',
  cuisine_type: 'cuisine_type',
  dietary_info: 'dietary_info',
  spice_level: 'spice_level',
  prep_time: 'prep_time',
  serving_size: 'serving_size',
  allergens: 'allergens',
  ingredients: 'ingredients',
  property_type: 'property_type',
  property_size: 'property_size',
  bedrooms: 'bedrooms',
  bathrooms: 'bathrooms',
  furnished: 'furnished',
  parking: 'parking',
  locality: 'locality',
  carpet_area: 'carpet_area',
  floor: 'floor',
  zoned_for: 'zoned_for',
  lease_terms: 'lease_terms',
  budget_range: 'budget_range',
  deal_type: 'deal_type',
  units_available: 'units_available',
  possession: 'possession',
  batch_number: 'batch_number',
  expiry_date: 'expiry_date',
  generic_name: 'generic_name',
  dosage: 'dosage',
  composition: 'composition',
  schedule: 'schedule',
};

// ✅ Helper function to get API key
export const getApiKey = (formKey) => {
  return FIELD_MAPPING[formKey] || formKey;
};